import { render, staticRenderFns } from "./CompoundDetails.vue?vue&type=template&id=239168eb&"
import script from "./CompoundDetails.vue?vue&type=script&lang=js&"
export * from "./CompoundDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports